import React from 'react';

const PADDING = {
  none: '',
  sm: 'p-4',
  md: 'p-4 sm:p-6',
  lg: 'p-6 sm:p-8'
};

const Card = ({ children, padding = 'md', hover = false, className = '', ...rest }) => (
  <div
    className={`bg-white dark:bg-slate-800 rounded-2xl sm:rounded-3xl shadow-xl shadow-slate-900/[0.04] dark:shadow-black/20 border border-slate-100 dark:border-slate-700 ${PADDING[padding] || PADDING.md} ${hover ? 'card-hover' : ''} ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default Card;
